import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectMode } from '../../../actions/commonActions'
import { _PHP } from '../../../actions/types'

const OBJECT = [ "receipt", "receipt", "receipt"]
const METHODS = {   
    receipt: [ "Receipt receipt = mpgReq.getReceipt();", "Receipt receipt = mpgReq.GetReceipt();", "$mpgResponse=$mpgHttpPost->getMpgResponse();"],
    get_response:[ ".getResponseCode()",".GetResponseCode();","$mpgResponse->getResponseCode()"],
    rec_success:[ ".getRecurSuccess();",".GetRecurSuccess();","$mpgResponse->getRecurSuccess()"],
    rec_update_success:[ ".getRecurUpdateSuccess();",".GetRecurUpdateSuccess();","$mpgResponse->getRecurUpdateSuccess()"],
    next_recur_date:[ ".getNextRecurDate();",".GetNextRecurDate();","$mpgResponse->getNextRecurDate()"],
    recur_end_date:[ ".getRecurEndDate();",".GetRecurEndDate();","$mpgResponse->getRecurEndDate()"],
}
export class ResponseCode extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide');
    }
    render() {
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">  
            <div>
            <h3 className="stepPageTitle">Recurring Billing Response Fields and Codes</h3>
            <p>Table 19 outlines the response fields that are part of recurring billing. Some are available when you set up
                recurring billing (such as with a Purchase transaction), and some are available when you update an existing
                transaction with the Recurring Billing transaction.
            </p>
            <p><b>Receipt object definition</b></p>   
           <code>{METHODS.receipt[progLangId]}</code>
        <h3 className="stepPageTitle" style={{ marginLeft:"25vw",fontSize:"1vw"}}>Table 19: Recurring Billing response fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Get method</th>
                    <th>Description</th>
                </tr>
                
                <tr>
                    <td style={{textAlign:"center"}} colspan="4">Transaction object with Recurring Billing response fields</td>
                </tr>

                <tr>
                    <td>Response code</td>
                    <td>String<br/>3-character numeric</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.get_response[progLangId]}</code></td>
                    <td>See Table 20: for a description of possible response codes.</td>
                </tr>
                <tr>
                    <td>Recur success</td>
                    <td>String<br/>TBD</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.rec_success[progLangId]}</code></td>
                    <td>Indicates whether the transaction successfully registered</td>
                </tr>
                                
                <tr>
                    <td style={{textAlign:"center"}} colspan="4">Recur update object response fields</td>
                </tr>

                <tr>
                    <td>Recur update success</td>
                    <td>String<br/><code>true/false</code></td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.rec_update_success[progLangId]}</code></td>
                    <td>Indicates whether the transaction successfully updated.</td>
                </tr>
                            

                <tr>
                    <td>Next recur date</td>
                    <td>String<br/>yyyy-mm-dd format</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.next_recur_date[progLangId]}</code></td>
                    <td>Indicates when the transaction will be billed again.</td>
                </tr>

                <tr>
                    <td>Recur end date</td>
                    <td>String<br/>yyyy-mm-dd format</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.recur_end_date[progLangId]}</code></td>
                    <td>Indicates when the Recurring Billing Transaction will end.</td>
                </tr>        
                </tbody>
            </table>

            <p>The Recur Update response is a 3-digit numeric value. The following is a list of all possible responses after
a Recur Update transaction has been sent.</p>

        <h3 className="stepPageTitle" style={{ marginLeft:"25vw",fontSize:"1vw"}}>Table 20: Recur update response codes</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Request Value</th>
                    <th>Definition</th>
                </tr>
                <tr>
                    <td>001</td>
                    <td>Recurring transaction successfully updated (optional: terminated)</td>
                </tr>
                <tr>
                    <td>983</td>
                    <td>Cannot find the previous transaction</td>
                </tr>
                <tr>
                    <td>984</td>
                    <td>Data error: (optional: field name)</td>
                </tr>
                <tr>
                    <td>985</td>
                    <td>Invalid number of recurs</td>
                </tr>
                <tr>
                    <td>986</td>
                    <td>Incomplete: timed out</td>
                </tr>
                <tr>
                    <td>null</td>
                    <td>Error: Malformed XML</td>
                </tr>
                </tbody>
            </table>

          </div>
        </div>
        )
    }
}

const mapStateToProps = state => {
    const {mode} = state.common.sideNav;
    const {progLangId}= state.common.progLangList.selection 
    return { mode,progLangId};
  }
  
export default connect(mapStateToProps, { selectMode})(ResponseCode)
  
  
  